import React from "react";

/**
 * Compact cross-route section tabs at the top of pages using `page-container--section-tabs`.
 */
export default function SectionTabsPageHeader({ children, subtitle = null }) {
  return (
    <div className="page-header">
      <div className="tabs-bar section-tabs-bar">{children}</div>
      {subtitle ? <p className="page-subtitle">{subtitle}</p> : null}
    </div>
  );
}
